var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ApiService } from './api.service';
import { UtilService } from './util.service';
import { Http } from '@angular/http';
var MasterService = /** @class */ (function () {
    function MasterService(apiService, util, http) {
        this.apiService = apiService;
        this.util = util;
        this.http = http;
    }
    MasterService.prototype.InitDropDown = function (system, action, data, id) {
        return __awaiter(this, void 0, void 0, function () {
            var res, obj, select, i, opt;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.apiService.post(system, action, data)];
                    case 1:
                        res = _a.sent();
                        $('#' + id).find('option').remove().end();
                        console.log(res);
                        if (res.isSuccess) {
                            obj = res.responseData;
                            select = document.getElementById(id);
                            for (i = 0; i < obj.length; i++) {
                                opt = document.createElement('option');
                                opt.value = obj[i].ddl_value;
                                opt.innerHTML = obj[i].ddl_text;
                                select.appendChild(opt);
                            }
                        }
                        else {
                            this.util.ErrorDialog(obj.errorMessage);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    MasterService.prototype.GetMaxUploadFileSize = function () {
        return __awaiter(this, void 0, void 0, function () {
            var Config, DefaultValue, ConfigAgentBank;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        Config = {};
                        DefaultValue = 10;
                        return [4 /*yield*/, this.apiService.get("master", "configuration")];
                    case 1:
                        Config = _a.sent();
                        if (Config != null && Config.length > 0) {
                            ConfigAgentBank = Config.filter(function (a) { return a.dpa_name == "UPLOAD_FILE_AGENT"; });
                            if (ConfigAgentBank != null && ConfigAgentBank.length > 0)
                                return [2 /*return*/, ConfigAgentBank[0].dpa_value];
                            else
                                return [2 /*return*/, DefaultValue];
                        }
                        else
                            return [2 /*return*/, DefaultValue];
                        return [2 /*return*/];
                }
            });
        });
    };
    // async GetAcceptUploadFileExtension() {
    //   var DefaultValue = ".jpg, .jpeg, .pdf, .doc, .docx";
    //   var Config: any = {}
    //   Config = await this.EnvConfig(); 
    //   if (Config == null)
    //     return DefaultValue;
    //   else
    //     return Config.AcceptUploadFileExtension;
    // }
    MasterService.prototype.GetCarousel = function (crisis) {
        return __awaiter(this, void 0, void 0, function () {
            var Config;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        Config = {};
                        return [4 /*yield*/, this.EnvConfig()];
                    case 1:
                        Config = _a.sent();
                        if (Config == null)
                            return [2 /*return*/, []];
                        else
                            return [2 /*return*/, crisis ? Config.carouselCrisis : Config.carousel];
                        return [2 /*return*/];
                }
            });
        });
    };
    MasterService.prototype.EnvConfig = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve) {
                        _this.http.get('./assets/env.json').toPromise().then(function (data) {
                            var res = data.json();
                            resolve(res);
                        }).catch(function (err) {
                            resolve(null);
                        });
                    })];
            });
        });
    };
    return MasterService;
}());
export { MasterService };



// WEBPACK FOOTER //
// ./src/app/utility/master.service.ts.pre-build-optimizer.js